import type { LucideIcon } from "lucide-react";
import { Card, Icon, Inline, Stack, Text } from "@generalapplications/ui";

import {
  RevealGroup,
  RevealItem,
} from "@/app/common/components/composite/motion/RevealGroup";
import { formatText } from "@/app/common/functions/format/formatText";

export type StatementListProps = {
  items: readonly string[];
  /** The marker before each statement, which says what kind they are. */
  icon: LucideIcon;
  ariaLabel?: string;
};

/** Statements, each on a quiet card behind a marker: content, never links. */
export function StatementList({ items, icon, ariaLabel }: StatementListProps) {
  return (
    <RevealGroup>
      <Stack as="ul" aria-label={ariaLabel} gap="sm">
        {items.map((item) => (
          <RevealItem key={item} as="li">
            <Card size="sm" radius="xl">
              <Inline align="start" gap="sm">
                <Icon icon={icon} tone="secondary" />
                <Text variant="body" weight="semibold">
                  {formatText(item)}
                </Text>
              </Inline>
            </Card>
          </RevealItem>
        ))}
      </Stack>
    </RevealGroup>
  );
}
